/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

import React from 'react';
import { Breadcrumb, Card, Col, Icon, Row } from 'antd';
import { constants } from '../../../../../../devUtils';
import { BOARD_OF_DIRECTORS } from '../../constants';

function DirectorsProfileDetails(props) {
  const { type } = props;
  const { DIRECTORS_PROFILES } = BOARD_OF_DIRECTORS;
  return (
    DIRECTORS_PROFILES[type].map(({
      title,
      imgUrl,
      imgAlt,
      description,
      designation,
    }) => (
      <section key={title}>
        <Breadcrumb className="directors-breadcrumb">
          <Breadcrumb.Item
            href={constants.BOARD_OF_DIRECTORS}
          >
            <Icon type="home" className="margin-r-1 font-16" />
            Board of Directors
          </Breadcrumb.Item>
          <Breadcrumb.Item
            className="current-breadcrumb"
          >{title}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Card
          className="directors-profile"
        >
          <Row type="flex" align="stretch" justify="start" gutter={[18, 18]}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img
                src={imgUrl}
                alt={imgAlt}
                className="director-img"
              />
            </Col>
            <Col xs={24} sm={24} md={18} lg={18} xl={18}>
              <h2 className="text-red fw-600">
                {title}
              </h2>
              <h3 className="text-black fw-600 font-18">
                {designation}
              </h3>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Col>
          </Row>
        </Card>
      </section>
    ))
  );
}

export default DirectorsProfileDetails;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/BoardOfDirectors/DirectorsProfile/DirectorsProfileDetails/index.jsx